import { Subject } from 'rxjs';
const userLoadedSubject = new Subject();
export default userLoadedSubject;
